import { env } from '$env/dynamic/public';

export const load = async ({ fetch, params }) => {
  const res = await fetch(env.PUBLIC_API_URL + '/web/blog/' + params.id);
  const post = await res.json();

  return {
    post
  };
};
